module.exports = __webpack_public_path__ + "static/favicon-128-805fbb5f05c1a560852b84ba3d6b4bd6.png";